import * as React from 'react';
import Stack from '@mui/material/Stack';
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import Paper from '@mui/material/Paper';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';

export default function CookiesBanner() {
  const [cookieBannerOpen, setCookieBannerOpen] = React.useState(false);
  // get cookie banner open from local storage
  useEffect(() => {
    const cookieBannerOpen = localStorage.getItem('cookieBannerOpen');
    if (!cookieBannerOpen) setCookieBannerOpen(true);
  }, []);

  const closeBanner = () => {
    setCookieBannerOpen(false);
    localStorage.setItem('cookieBannerOpen', 'false');
  };

  return (
    <React.Fragment>
      <TrapFocus open disableAutoFocus disableEnforceFocus>
        <Fade appear={false} in={cookieBannerOpen}>
          <Paper
            role="dialog"
            aria-modal="false"
            aria-label="Cookie banner"
            square
            variant="outlined"
            tabIndex={-1}
            sx={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              m: 0,
              p: 2,
              borderWidth: 0,
              borderTopWidth: 1,
              zIndex: (theme) => theme.zIndex.drawer + 2,
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              sx={{ justifyContent: 'space-between', gap: 2 }}
            >
              <Box
                sx={{ flexShrink: 1, alignSelf: { xs: 'flex-start', sm: 'center' } }}
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  This website uses cookies
                </Typography>
                <Typography variant="body2">
                  {window.location.hostname} relies on cookies to improve your experience.
                </Typography>
              </Box>
              <Stack
                direction={{
                  xs: 'row-reverse',
                  sm: 'row',
                }}
                sx={{
                  gap: 2,
                  flexShrink: 0,
                  alignSelf: { xs: 'flex-end', sm: 'center' },
                }}
              >
                <Button size="small" onClick={closeBanner} variant="contained"  sx={{ width: 150, background: '#0f0f0f', color: 'white', fontWeight: 600, borderRadius: 10, paddingTop: 1, paddingBottom: 1}}>
                  Allow all
                </Button>
                <Button size="small" onClick={closeBanner} variant='outlined' sx={{ width: 150, color: 'black', fontWeight: 600, borderRadius: 10, paddingTop: 1, paddingBottom: 1}}>
                  Reject all
                </Button>
              </Stack>
            </Stack>
          </Paper>
        </Fade>
      </TrapFocus>
    </React.Fragment>
  );
}
